import { CSSProperties, SVGProps } from 'react'
import Colors from 'modules/Colors'

interface LinkedInFlatIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

/**
 * LinkedIn flat icon component
 */
const LinkedInFlatIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 40,
    onClick
}: LinkedInFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_453_146)">
                <path
                    d="M30.8887 6C32.6069 6 34 7.39311 34 9.11133V30.8887C34 32.6069 32.6069 34 30.8887 34H9.11133C7.39311 34 6 32.6069 6 30.8887V9.11133C6 7.39311 7.39311 6 9.11133 6H30.8887ZM10.29 30.1113H14.4658V16.6299H10.29V30.1113ZM25.2041 16.2178C22.3617 16.2179 21.1549 18.4172 21.1396 18.4453V16.6299H17.1348V30.1113H21.1396V23.0342C21.1396 21.1381 22.0122 20.01 23.6826 20.0098C25.2184 20.0098 25.9561 21.0939 25.9561 23.0342V30.1113H30.1113V21.5752C30.1112 17.9639 28.0636 16.2178 25.2041 16.2178ZM12.3584 9.88867C10.9945 9.88867 9.88867 11.0031 9.88867 12.377C9.88885 13.7506 10.9946 14.8643 12.3584 14.8643C13.7221 14.8641 14.826 13.7505 14.8262 12.377C14.8262 11.0032 13.7222 9.88883 12.3584 9.88867Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_453_146">
                    <rect width="28" height="28" fill="white" transform="translate(6 6)"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default LinkedInFlatIcon
